import React from 'react';
import './DrawerTrigger.less';
import {Trigger} from 'new-components/elements/trigger/Trigger';
import DropdownIcon from 'new-images/dropdown.svg';

export const DrawerTrigger = ({caption, onClick}) => {
	return (
		<Trigger onClick={onClick}>
			<div className="drawer-trigger">
				<span className="drawer-trigger__caption">{caption}</span>
				<span className="drawer-trigger__icon" dangerouslySetInnerHTML={{__html: DropdownIcon}}></span>
			</div>
		</Trigger>
	);
};
